<template>
  <div class="btn_box">
    <div
      class="btn"
      v-for="item in type === '1' ? home : view"
      :key="item"
      @click="handleItem(item.text)"
    >
      <img :src="item.img" alt="" class="icon" />
      <div class="text">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: {
      type: String,
      defalut: "",
    },
  },
  data() {
    const view = [
      {
        img: require("../assets/image/pic/home.png"),
        text: "平台首页",
      },
      {
        img: require("../assets/image/pic/personal_center.png"),
        text: "个人中心",
      },
      {
        img: require("../assets/image/pic/setting.png"),
        text: "设置",
      },
      {
        img: require("../assets/image/pic/exit.png"),
        text: "退出",
      },
    ];

    const home = [
      {
        img: require("../assets/image/pic/personal_center.png"),
        text: "退出",
      },
    ];

    const handleItem = (e) => {
      switch (e) {
        case "平台首页":
          console.log("平台首页");
          this.$router.push({
            name: "Home",
          });
          break;
        case "个人中心":
          console.log("个人中心");
          break;
        case "设置":
          console.log("设置");
          break;
        default:
          console.log("退出");
          localStorage.clear();
          this.$router.push({
            name: "Login",
          });
          break;
      }
    };
    return { handleItem, home, view };
  },
};
</script>
<style lang="scss" scoped>
.btn_box {
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-left: 40%;
  box-sizing: border-box;
  .btn {
    background: url("../assets/image/pic/header_bor.png") no-repeat center
      center;
    background-size: 100% 100%;
    text-align: center;
    padding: 0 rpx(23);
    box-sizing: border-box;
    margin-left: 3%;
    margin-top: 1%;
    cursor: pointer;
    &:last-of-type {
      margin-right: 2%;
    }

    .icon {
      width: 16px;
      height: 16px;
    }
    .text {
      font: normal 14px/16px "微软雅黑";
      color: #fff;
    }
  }
}
</style>
